module.exports = __webpack_public_path__ + "static/media/profile-hand-top.27dcaba1.svg";